import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <header className="bg-[#FDF8F0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-98">
      <div className="max-w-4xl mx-auto text-center" data-id="element-99">
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-[#3D2E1F] mb-6 leading-tight" data-id="element-100">
          DESPIERTA SIN DOLOR: TU DIARIO DE 5 MINUTOS PARA ARTICULACIONES
          FELICES
        </h1>

        <h2 className="font-lato text-xl md:text-2xl text-[#3D2E1F] opacity-90 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-101">
          Diseñado exclusivamente para mujeres de 65+ que desean recuperar la
          movilidad de sus manos y rodillas sin depender de fármacos agresivos.
        </h2>

        <div className="mb-12 rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/aHPUAcW7Du8wtKkrn7RZ7u/heylloyd-image-1772926088662.png" alt="Mujer mayor sonriendo mientras toma café en su cama, leyendo el diario de articulaciones felices en su tableta" className="w-full h-auto object-cover max-h-[600px]" data-id="element-103" />
        </div>

        <CTAButton aria-label="Comprar el diario Despierta Sin Dolor ahora" onClick={() => document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-104">
          ¡QUIERO DESPERTAR SIN DOLOR AHORA!
        </CTAButton>
      </div>
    </header>;
}